import React from 'react'
import { PropsWithChildren } from 'react'
import { Route, Switch } from 'react-router-dom'
import Redirect from '../Redirect/Redirect'
import Thanx from '../Thanx/Thanx'
import Welcome from '../Welcome/Welcome'
import Progress from '../Wizard/Progress/Progress'

const AppRouting: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
    return (
        <Switch>
            <Route exact path='/' component={Welcome}></Route>
            <Route path='/wizard' component={Progress}></Route>
            <Route path='/thanks' component={Thanx}></Route>
            <Route path='/redirect' component={Redirect}></Route>
        </Switch>
    )
}
export default AppRouting
